import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

const cache = new InMemoryCache();

const link = new HttpLink({
  uri: 'graphql',

  // Use explicit `window.fetch` so that outgoing requests
  // are captured and deferred until the Service Worker is ready.
  fetch: (...args) => fetch(...args),
});

// Isolate Apollo client so it could be reused
// in both application runtime and tests.
export const MockApolloClient = new ApolloClient({
  cache,
  link,
});
